
import { get, post } from '@/common/request/index';

/**
 * 分类树
 * https://yapi.lanhanba.com/project/532/interface/api/99696
 */
export function getBotCategoryTree(params?) {
  return get('/v2/bot/script/category/tree', params, { needHint: true });
}

/**
 * 话术分页列表（仅返回启用状态）
 * https://yapi.lanhanba.com/project/532/interface/api/99698
 */
export function postBotList(params?) {
  return post('/v2/bot/script/list', params, { needHint: true });
}

/**
 * 分页查询 AI 陪练场景（仅返回启用状态）
 * https://yapi.lanhanba.com/project/532/interface/api/99762
 */
export function postAiTrainingScenarioPage(params?) {
  return post('/v2/bot/ai-training-scenario/page', params, { needHint: true });
}

/**
 * 新增陪练记录
 * https://yapi.lanhanba.com/project/532/interface/api/99756
 */
export function postAiTrainingRecordCreate(params?) {
  return post('/v2/bot/ai-training-record/create', params, { needHint: true });
}

/**
 * 查询 AI 陪练记录详情
 * https://yapi.lanhanba.com/project/532/interface/api/99760
 */
export function postAiTrainingRecordDetail(params?, options?) {
  return post('/v2/bot/ai-training-record/detail', params, { needHint: false, needCancel: false, ...options });
}

/**
 * 分页查询我的陪练记录
 * https://yapi.lanhanba.com/project/532/interface/api/99754
 */
export function postMyAiTrainingRecordPage(params?) {
  return post('/v2/bot/ai-training-record/page/my', params, { needHint: true });
}

/**
 * 收藏话术
 * https://yapi.lanhanba.com/project/532/interface/api/99700
 */
export function postBotFavorite(params?) {
  return post('/v2/bot/script/favorite', params, { needHint: true });
}

/**
 * 取消收藏
 * https://yapi.lanhanba.com/project/532/interface/api/99702
 */
export function postBotFavoriteRemove(params?) {
  return post('/v2/bot/script/favorite/remove', params, { needHint: true });
}

/**
 * 门店列表
 * https://yapi.lanhanba.com/project/532/interface/api/99716
 */
export function getBotStoreList(params?) {
  return get('/v2/bot/store/list', params, { needHint: true });
}

/**
 * 当前绑定门店
 * https://yapi.lanhanba.com/project/532/interface/api/99720
 */
export function getBotStoreCurrent(params?) {
  return get('/v2/bot/store/current', params, { needHint: true });
}

/**
 * 绑定/切换门店
 * https://yapi.lanhanba.com/project/532/interface/api/99718
 */
export function postBotStoreBind(params?) {
  return post('/v2/bot/store/bind', params, { needHint: true });
}

/**
 * 客户分页
 * https://yapi.lanhanba.com/project/670/interface/api/99764
 */
export function getBotCustomerPage(params?) {
  return get('/v2/bot/customer/page', params, { needHint: true });
}

/**
 * 客户详情
 * https://yapi.lanhanba.com/project/670/interface/api/99766
 */
export function getBotCustomerDetail(id: number | string) {
  return get(`/v2/bot/customer/detail/${id}`, {}, { needHint: true });
}

/**
 * 新增客户
 * https://yapi.lanhanba.com/project/670/interface/api/99768
 */
export function postBotCustomerCreate(params?) {
  return post('/v2/bot/customer/create', params, { needHint: true });
}

/**
 * 编辑客户
 * https://yapi.lanhanba.com/project/670/interface/api/99770
 */
export function postBotCustomerUpdate(id: number | string, params?) {
  return post(`/v2/bot/customer/update/${id}`, params, { needHint: true });
}

/** 当日日报状态与内容 https://yapi.lanhanba.com/project/532/interface/api/99722 */
export function getBotDailyReport() {
  return get('/v2/bot/daily-report/today', {}, { needHint: true });
}

/** 保存日报草稿 https://yapi.lanhanba.com/project/532/interface/api/99724 */
export function saveBotDailyReportDraft(params?) {
  return post('/v2/bot/daily-report/draft', params, { needHint: true });
}

/** 提交日报 https://yapi.lanhanba.com/project/532/interface/api/99726 */
export function submitBotDailyReport(params?) {
  return post('/v2/bot/daily-report/submit', params, { needHint: true });
}

/** 覆盖更新日报 https://yapi.lanhanba.com/project/532/interface/api/99728 */
export function updateBotDailyReport(params?) {
  return post('/v2/bot/daily-report/update', params, { needHint: true });
}

/** 日报记录列表 https://yapi.lanhanba.com/project/532/interface/api/99730 */
export function getBotDailyReportHistory(params?) {
  return get('/v2/bot/daily-report/history', params, { needHint: true });
}

/** 日报详情 https://yapi.lanhanba.com/project/532/interface/api/99732 */
export function getBotDailyReportDetail(id) {
  return get(`/v2/bot/daily-report/detail/${id}`, {}, { needHint: true });
}

/** 查询当周周报状态 https://yapi.lanhanba.com/project/532/interface/api/99796 */
export function getBotWeeklyReportCurrent() {
  return get('/v2/bot/weekly-report/current', {}, { needHint: true });
}

/** 保存周报草稿 https://yapi.lanhanba.com/project/532/interface/api/99798 */
export function saveBotWeeklyReportDraft(params?) {
  return post('/v2/bot/weekly-report/draft', params, { needHint: true });
}

/** 提交周报 https://yapi.lanhanba.com/project/532/interface/api/99800 */
export function submitBotWeeklyReport(params?) {
  return post('/v2/bot/weekly-report/submit', params, { needHint: true });
}

/** 更新周报 https://yapi.lanhanba.com/project/532/interface/api/99802 */
export function updateBotWeeklyReport(params?) {
  return post('/v2/bot/weekly-report/update', params, { needHint: true });
}

/** 周报提交记录 https://yapi.lanhanba.com/project/532/interface/api/99804 */
export function getBotWeeklyReportHistory(params?) {
  return get('/v2/bot/weekly-report/history', params, { needHint: true });
}

/** 周报详情 https://yapi.lanhanba.com/project/532/interface/api/99806 */
export function getBotWeeklyReportDetail(id) {
  return get(`/v2/bot/weekly-report/detail/${id}`, {}, { needHint: true });
}

/** 查询当月月报状态 https://yapi.lanhanba.com/project/532/interface/api/99818 */
export function getBotMonthlyReportCurrent() {
  return get('/v2/bot/monthly-report/current', {}, { needHint: true });
}

/** 保存月报草稿 https://yapi.lanhanba.com/project/532/interface/api/99820 */
export function saveBotMonthlyReportDraft(params?) {
  return post('/v2/bot/monthly-report/draft', params, { needHint: true });
}

/** 提交月报 https://yapi.lanhanba.com/project/532/interface/api/99822 */
export function submitBotMonthlyReport(params?) {
  return post('/v2/bot/monthly-report/submit', params, { needHint: true });
}

/** 更新月报 https://yapi.lanhanba.com/project/532/interface/api/99824 */
export function updateBotMonthlyReport(params?) {
  return post('/v2/bot/monthly-report/update', params, { needHint: true });
}

/** 月报提交记录 https://yapi.lanhanba.com/project/532/interface/api/99826 */
export function getBotMonthlyReportHistory(params?) {
  return get('/v2/bot/monthly-report/history', params, { needHint: true });
}

/** 月报详情 https://yapi.lanhanba.com/project/532/interface/api/99828 */
export function getBotMonthlyReportDetail(id) {
  return get(`/v2/bot/monthly-report/detail/${id}`, {}, { needHint: true });
}
